/**
 * Copyright © 2025 Farmlands Co-operative Society Limited. All rights reserved.
 *
 * This document contains confidential information and is the property of Farmlands.
 * Unauthorised reproduction or distribution of any part of this publication is prohibited without written consent.
 */

import React from 'react';
import { Box, Stack, Typography, Button, useMediaQuery, useTheme } from '@mui/material';
import apiClient from '../../../../services/api-client';
import { useSelector } from 'react-redux';
import { selectConfigByKey } from '../../../../services/firebase/remote-config/remoteConfig.slice';
import { selectCurrentFarmerAccount } from '../../../azure-b2c/storage';
import TraderBanner from '../../../../assets/images/farmer-and-dog.png';
import { useNavigate } from 'react-router-dom';

export const TraderSpecialsBanner = () => {
  const traderSpecialsEnabled = useSelector(selectConfigByKey('traderSpecialsEnabled'));
  const account = useSelector(selectCurrentFarmerAccount);
  const navigate = useNavigate();
  const theme = useTheme();
  const isSm = useMediaQuery(theme.breakpoints.down('sm'));

  if (!traderSpecialsEnabled) return null;

  return (
    <Box
      display='flex'
      height='318px'
      sx={{
        background: `url(${TraderBanner})`,
        backgroundPosition: 'right',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
      }}
      onClick={() => {
        apiClient
          .post('/events', {
            event: 'offer-clicked',
            offerDetails: 'farmlands-pro-monthly-trader-specials',
            accountNumber: account?.accountNumber,
          })
          .catch((e) => {
            console.error(e);
          });
        navigate(
          '/products?tab=0&s=%22FPTD1%22&category=All+available+categories&dt=&df=&pt=&pf=&st=Best+Match&page=1',
        );
      }}
    >
      <Box
        sx={{
          width: '100%',
          background: 'linear-gradient(271deg, rgba(0, 85, 61, 0.00) 4.44%, #00553D 102.54%)',
        }}
      >
        <Stack
          spacing={2}
          sx={{
            width: '100%',
            height: '100%',
            background: `radial-gradient(100% 214.69% at 2.45% 28.19%, #00553D 0%, rgba(0, 85, 61, 0.00) 100%)`,
            padding: '32px',
          }}
        >
          <Stack spacing={1} flexWrap='wrap'>
            <Typography variant='h1' color='white'>
              Exclusive Offers!
            </Typography>
            <Typography variant='h2' color='white' maxWidth={isSm ? '100%' : '60%'}>
              Deals on selected Dog Food, Fencing Wire and Herbicide products
            </Typography>
          </Stack>
          <Box>
            <Button color='tertiary' variant='outlined'>
              See offers
            </Button>
          </Box>
        </Stack>
      </Box>
    </Box>
  );
};
